import { showToast } from "components/toast/Toast"; // Assuming you have similar constants for plan types
import {
  UPDATE_SUBSCRIPTION,
  GET_SUBSCRIPTION_BY_ID,
} from "constants/endpoints";

export const updateSubscription = async ({ apiCall, payload }) => {
  try {
    const response = await apiCall.patch(UPDATE_SUBSCRIPTION, payload);
    if (response) {
      showToast({
        message: "Subscription Updated Successfully!",
        success: true,
        customStyle: {
          background: "#52c41a",
          color: "#fff",
          padding: "10px",
        },
      });
    }
    return response;
  } catch (error) {
    showToast({
      message: error?.response?.data?.error?.message
        ? error?.response?.data?.error?.message
        : error?.response?.data?.error || "Something went wrong!",
      success: false,
      customStyle: {
        background: "#F24052",
        color: "#fff",
        padding: "10px",
      },
    });
  }
};

export const getFormData = async ({ apiCall, subscription_id }) => {
  try {
    const response = await apiCall.post(GET_SUBSCRIPTION_BY_ID, {
      subscription_id,
    });
    return response?.data;
  } catch (error) {
    showToast({
      message:
        error.response?.data?.error?.message ||
        error.message ||
        "Error in getting subscription details",
      success: false,
      customStyle: {
        background: "#F24052",
        color: "#fff",
        padding: "10px",
      },
    });
  }
};
